import { render, staticRenderFns } from "./card-group.vue?vue&type=template&id=2a2c922d&scoped=true&"
import script from "./card-group.vue?vue&type=script&lang=js&"
export * from "./card-group.vue?vue&type=script&lang=js&"
import style0 from "./card-group.vue?vue&type=style&index=0&id=2a2c922d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2c922d",
  null
  
)

export default component.exports